import { requestZendeskForm } from 'services';
import { ExchangeReturnFormData, PostFormResponse } from 'types';

async function postImageAndGetToken(file: File): Promise<string> {
  let result = '';

  try {
    const response = await requestZendeskForm.post(
      `attachment?filename=${file.name}`,
      file,
      {
        method: 'post',
        headers: {
          'Content-Type': `${file.type}`,
        },
      }
    );

    result = response.data.token;
  } catch (error) {
    console.error(error);
  }

  return result;
}

async function postFormData(
  formData: ExchangeReturnFormData
): Promise<PostFormResponse> {
  let result;
  var data = JSON.stringify(formData);

  try {
    const response = await requestZendeskForm.post('ticket/store-sale', data, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return result;
}

export const exchangeFormServices = { postImageAndGetToken, postFormData };
